
import Vue from 'vue'

export default Vue.extend({
  props: {
    color: {
      type: String,
      required: false,
      default: 'general',
    },
  },
  methods: {
    clickTag(color:string) {
      let url = ''
      if (color === 'sex') {
        url = 'https://jobrainbow.jp/magazine/biologicalsex'
      } else if (color === 'gender_identity') {
        url = 'https://jobrainbow.jp/magazine/genderidentity'
      } else if (color === 'gender_expression') {
        url = 'https://jobrainbow.jp/magazine/sexorientation'
      } else if (color === 'sexual_orientation') {
        url = 'https://jobrainbow.jp/magazine/romanticorientation'
      } else if (color === 'romantic_orientation') {
        url = 'https://jobrainbow.jp/magazine/romanticorientation'
      }
      window.location.href = url
    }
  }
})
